import React from 'react';
import { useCssHandles } from '../../../utils/functions';

import { useCurrentSeller } from '../SellerBody/CurrentSellerContext';

const SELLERS_CSS_HANDLES = ['sellerName'] as const;

function SellerName({ componentId, blockClass }: any) {
	const { currentSeller } = useCurrentSeller();
	const { handles }: any = useCssHandles(`vtex-seller-selector-0-x`, SELLERS_CSS_HANDLES, blockClass);

	return (
		<p
			data-selection={componentId}
			className={`${handles.sellerName} items-center tc w-100-s w-20-m  br2 ph6 pv4 ma0 b`}
		>
			{currentSeller?.sellerName}
		</p>
	);
}

export default SellerName;
